import React, { FC } from 'react';
import { Navigate, Routes, Route } from 'react-router-dom';
import { shallowEqual, useSelector } from 'react-redux';
import { MasterLayout } from '../../_metronic/layout/MasterLayout';
import { PrivateRoutes } from './PrivateRoutes';
import { Logout, AuthPage } from '../modules/auth';
import { ErrorsPage } from '../modules/errors/ErrorsPage';
import { RootState } from '../../setup';

const AppRoutes: FC = () => {
  const isAuthorized = useSelector<RootState>(({ auth }) => auth.user && !auth.requiresVerification, shallowEqual);

  return (
    <Routes>
      {!isAuthorized ? (
        /* Render auth page when user is not authorized */
        <Route path="/auth/*" element={<AuthPage />} />
      ) : (
        /* Redirect to root page (`/`) */
        <Route path="/auth/*" element={<Navigate to="/" replace />} />
      )}

      <Route path="/error" element={<ErrorsPage />} />
      <Route path="/logout" element={<Logout />} />

      {!isAuthorized ? (
        /* Redirect to `/auth` when user is not authorized */
        <Route path="*" element={<Navigate to="/auth/login" replace />} />
      ) : (
        /* Load private routes inside MasterLayout */
        <Route path="*" element={<MasterLayout><PrivateRoutes /></MasterLayout>} />
      )}
    </Routes>
  );
};

export { AppRoutes };
